import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getPurposelandData(context) {
      const response = await Vue.axios.get(`${URL_API}purposeland`);
      let data = response["data"];
      context.commit("updatePurposelandData", data);
    },
    async createPurposelandData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}purposeland/store`, body, config);
      context.dispatch("getPurposelandData");
    },
    async pushPurposelandData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}purposeland/update`, body, config);
      context.dispatch("getPurposelandData");
    },
    async destroyPurposelandData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}purposeland/destroy`, body, config);
      context.dispatch("getPurposelandData");
    }
  },
  mutations: {
    updatePurposelandData(state, purposelandData) {
      state.purposelandData = purposelandData;
    }
  },
  state: {
    purposelandData: []
  },
  getters: {
    allPurposelandData(state) {
      return state.purposelandData;
    }
  }
};